
import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	DphSzbOzn: null as string | null,
	LakGarSzb: null as number | null,
	LakZakSzb: null as number | null,
	LakdruhId: null as number | null,
	LakdruhOzn: null as string | null,
	NdNr: null as string | null,
	OvozidloPrp: null as boolean | null,
	S2ExtPrp: null as boolean | null,
	Text: null as string | null,
	VyrazenPrp: null as boolean | null,
	VyrobekvozOzn: null as string | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekvozOzn: [],
		DphSzbOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
